import React, { useState, useEffect } from "react";
import { ArrowBack as ArrowBackIcon, ExitToApp as SignOutIcon } from "@material-ui/icons";
import { Avatar, Divider, Drawer, IconButton, List, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar
} from "../../context/LayoutContext";
import Rest from "../../helpers/Rest";

function getSidebarUser() {
  for (const k of Object.keys(localStorage)) {
    if (k.indexOf("user_details") === 0) {
      try {
        const u = JSON.parse(localStorage.getItem(k));
        if (u && (u.email || u.name)) return u;
      } catch (e) {}
    }
  }
  return {};
}

function sidebarInitials(user) {
  const src = ((user && (user.name || user.email)) || "").trim();
  if (!src) return "?";
  const parts = src.split(/[\s@._-]+/).filter(Boolean);
  return (((parts[0] || "")[0] || "") + ((parts[1] || "")[0] || "")).toUpperCase() || "?";
}

function Sidebar({ location, structure }) {
  const classes = useStyles(), theme = useTheme();

  const toggleDrawer = value => event => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    if (value && !isPermanent) toggleSidebar(layoutDispatch);
  };

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);

  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  const sidebarOpen = !isPermanent ? !isSidebarOpened : isSidebarOpened;
  const profileUser = getSidebarUser();

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: !isPermanent ? !isSidebarOpened : isSidebarOpened,
        [classes.drawerClose]: !isPermanent ? isSidebarOpened : !isSidebarOpened
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: !isPermanent
            ? !isSidebarOpened
            : isSidebarOpened,
          [classes.drawerClose]: !isPermanent
            ? isSidebarOpened
            : !isSidebarOpened
        })
      }}
      open={!isPermanent ? !isSidebarOpened : isSidebarOpened}
      onClose={toggleDrawer(true)}
    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse)
            }}
          />
        </IconButton>
      </div>
      <List
        className={classes.sidebarList}
        classes={{ padding: classes.padding }}
      >
        {structure.filter(link => link.public || Rest.isAdmin).map(link => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={!isPermanent ? !isSidebarOpened : isSidebarOpened}
            {...link}
            toggleDrawer={toggleDrawer(true)}
          />
        ))}
      </List>
      <div className={classes.sidebarSpacer} />
      <Divider className={classes.profileDivider} />
      <div className={classes.profile}>
        <Avatar className={classes.profileAvatar}>
          {sidebarInitials(profileUser)}
        </Avatar>
        {sidebarOpen && (
          <div className={classes.profileText}>
            <Typography className={classes.profileName} noWrap>
              {profileUser.name || profileUser.email || "Account"}
            </Typography>
            <Typography className={classes.profileEmail} noWrap>
              {profileUser.email}
            </Typography>
          </div>
        )}
        {sidebarOpen && (
          <IconButton
            size="small"
            className={classes.profileSignOut}
            onClick={() => {
              Rest.logout();
              window.location.hash = "/login";
            }}
            title="Sign out"
          >
            <SignOutIcon fontSize="small" />
          </IconButton>
        )}
      </div>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
